// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 416 ? "component---gatsby-theme-landing-page-src-pages-contentful-landing-page-slug-js" : chunkId) + "-" + {"416":"cfe9cb3a8b61565e1237","452":"a3ce6e09076a89a6cd7f","896":"374e453c944b47526c69"}[chunkId] + ".js";
};